module.exports = __webpack_public_path__ + "static/media/packet_no.4ad36f05.png";